import React, { useState } from "react";
import { ReactTyped } from "react-typed";

const HeroTypewriter = () => {
	return (
		<>
			<div className="flex flex-col gap-2 border rounded-2xl">
				<h2 className="text-xl lg:text-2xl p-2 text-gray-500 relative bottom-1">
					<ReactTyped
						strings={["Developer. Designer. Friend :)"]}
						typeSpeed={100}
						backSpeed={100}
						startDelay={500}
						cursorChar="|"
						showCursor
					/>
				</h2>
			</div>
		</>
	);
};

export default HeroTypewriter;
